var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPropeller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.45,16.67h0a24,24,0,0,0-5.27-1.74,2.29,2.29,0,0,0-1-2.52,1.85,1.85,0,0,0-.45-.21h0a33.29,33.29,0,0,0,1.21-5.11l0,.24c.47-2.9-.68-4.21-2-4.21-1.55,0-1.76,1.79-1.62,3.64a22.91,22.91,0,0,0,1.12,5.37v0a2.3,2.3,0,0,0-1.63,2.66h0A33.43,33.43,0,0,0,5,16.24l-.09,0c-2.74,1-3.29,2.68-2.62,3.87.76,1.35,2.41.64,4-.41a22.86,22.86,0,0,0,4-3.58l.1-.11a3,3,0,0,0,.4.31h0a2.3,2.3,0,0,0,2.69-.23h0A33.37,33.37,0,0,0,17,19.44l.15.11c2.27,1.86,4,1.52,4.67.33S21.13,17.48,19.45,16.67Zm-6.64-1.76a1,1,0,0,1-1.72-1,1,1,0,0,1,1.37-.35h0A1,1,0,0,1,12.81,14.91Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPropeller);
export default __webpack_public_path__ + "static/media/icon_propeller.50581ffe5a390a5784b5aef1919c6e1e.svg";
export { ForwardRef as ReactComponent };